














































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator'
import {StoreModel} from "@/views/Objekti/StoreModel";

@Component({})
export default class ObjektiCard2Tab10Pozicije extends Vue {
  @Prop() store!: StoreModel;
  @Prop() secondaryPositions!: [];

  positionSettings = [];

  selectedType: { id: '', model: [], image: '' }


  ctx: any = '';
  selected = [];
  image = 'assets/images/standard_tt.png';
  model = [];

  async created() {
    this.positionSettings = [
      {id: 1, text: 'Standardna TT', image: 'assets/images/standard_tt.png',
        model: [
          {rate: 2, bounds: [{x: 0, y: 60}, {x: 30, y: 90}]}, {rate: 4, bounds: [{x: 30, y: 60}, {x: 60, y: 90}]},                                                                                                                    {rate: 5, bounds: [{x: 120, y: 60}, {x: 150, y: 90}]}, {rate: 3, bounds: [{x: 150, y: 60}, {x: 180, y: 90}]},
          {rate: 2, bounds: [{x: 0, y: 90}, {x: 30, y: 120}]}, {rate: 4, bounds: [{x: 30, y: 90}, {x: 60, y: 120}]},                                                                                                                  {rate: 5, bounds: [{x: 120, y: 90}, {x: 150, y: 120}]}, {rate: 3, bounds: [{x: 150, y: 90}, {x: 180, y: 120}]},
          {rate: 2, bounds: [{x: 0, y: 120}, {x: 30, y: 150}]}, {rate: 4, bounds: [{x: 30, y: 120}, {x: 60, y: 150}]},                                                                                                                {rate: 5, bounds: [{x: 120, y: 120}, {x: 150, y: 150}]}, {rate: 3, bounds: [{x: 150, y: 120}, {x: 180, y: 150}]},
          {rate: 2, bounds: [{x: 0, y: 150}, {x: 30, y: 180}]}, {rate: 3, bounds: [{x: 30, y: 150}, {x: 60, y: 180}]}, {rate: 3, bounds: [{x: 60, y: 150}, {x: 90, y: 180}]}, {rate: 4, bounds: [{x: 90, y: 150}, {x: 120, y: 180}]}, {rate: 4, bounds: [{x: 120, y: 150}, {x: 150, y: 180}]}, {rate: 4, bounds: [{x: 150, y: 150}, {x: 180, y: 180}]}, {rate: 3, bounds: [{x: 180, y: 150}, {x: 210, y: 180}]},
          {rate: 2, bounds: [{x: 0, y: 180}, {x: 30, y: 210}]}, {rate: 2, bounds: [{x: 30, y: 180}, {x: 60, y: 210}]}, {rate: 2, bounds: [{x: 60, y: 180}, {x: 90, y: 210}]}, {rate: 3, bounds: [{x: 90, y: 180}, {x: 120, y: 210}]}, {rate: 3, bounds: [{x: 120, y: 180}, {x: 150, y: 210}]}, {rate: 3, bounds: [{x: 150, y: 180}, {x: 180, y: 210}]}, {rate: 2, bounds: [{x: 180, y: 180}, {x: 210, y: 210}]},
          {rate: 1, bounds: [{x: 0, y: 210}, {x: 30, y: 240}]}, {rate: 1, bounds: [{x: 30, y: 210}, {x: 60, y: 240}]}, {rate: 1, bounds: [{x: 60, y: 210}, {x: 90, y: 240}]}, {rate: 1, bounds: [{x: 90, y: 210}, {x: 120, y: 240}]}, {rate: 1, bounds: [{x: 120, y: 210}, {x: 150, y: 240}]}, {rate: 1, bounds: [{x: 150, y: 210}, {x: 180, y: 240}]}, {rate: 1, bounds: [{x: 180, y: 210}, {x: 210, y: 240}]},
        ]},
      {id: 2, text: 'Moderna radnja', image: 'assets/images/modern.png',
        model: [
          {rate: 4, bounds: [{x: 0, y: 60}, {x: 30, y: 90}] }, {rate: 5, bounds: [{x: 30, y: 60}, {x: 60, y: 90}] }, {rate: 5, bounds: [{x: 60, y: 60}, {x: 90, y: 90}] }, {rate: 5, bounds: [{x: 90, y: 60}, {x: 120, y: 90}] }, {rate: 5, bounds: [{x: 120, y: 60}, {x: 150, y: 90}] }, {rate: 5, bounds: [{x: 180, y: 60}, {x: 210, y: 90}] }, {rate: 5, bounds: [{x: 210, y: 60}, {x: 240, y: 90}] }, {rate: 5, bounds: [{x: 240, y: 60}, {x: 270, y: 90}] }, {rate: 5, bounds: [{x: 270, y: 60}, {x: 300, y: 90}] }, {rate: 4, bounds: [{x: 300, y: 60}, {x: 330, y: 90}] }, {rate: 4, bounds: [{x: 330, y: 60}, {x: 360, y: 90}] },
          {rate: 4, bounds: [{x: 0, y: 90}, {x: 30, y: 120}] }, {rate: 5, bounds: [{x: 30, y: 90}, {x: 60, y: 120}] }, {rate: 5, bounds: [{x: 60, y: 90}, {x: 90, y: 120}] }, {rate: 5, bounds: [{x: 90, y: 90}, {x: 120, y: 120}] }, {rate: 5, bounds: [{x: 120, y: 90}, {x: 150, y: 120}] }, {rate: 5, bounds: [{x: 180, y: 90}, {x: 210, y: 120}] }, {rate: 5, bounds: [{x: 210, y: 90}, {x: 240, y: 120}] }, {rate: 5, bounds: [{x: 240, y: 90}, {x: 270, y: 120}] }, {rate: 5, bounds: [{x: 270, y: 90}, {x: 300, y: 120}] }, {rate: 4, bounds: [{x: 300, y: 90}, {x: 330, y: 120}] }, {rate: 4, bounds: [{x: 330, y: 90}, {x: 360, y: 120}] },
          {rate: 4, bounds: [{x: 0, y: 120}, {x: 30, y: 150}] }, {rate: 5, bounds: [{x: 30, y: 120}, {x: 60, y: 150}] }, {rate: 5, bounds: [{x: 60, y: 120}, {x: 90, y: 150}] }, {rate: 5, bounds: [{x: 90, y: 120}, {x: 120, y: 150}] }, {rate: 5, bounds: [{x: 120, y: 120}, {x: 150, y: 150}] }, {rate: 5, bounds: [{x: 180, y: 120}, {x: 210, y: 150}] }, {rate: 5, bounds: [{x: 210, y: 120}, {x: 240, y: 150}] }, {rate: 4, bounds: [{x: 240, y: 120}, {x: 270, y: 150}] }, {rate: 4, bounds: [{x: 270, y: 120}, {x: 300, y: 150}] }, {rate: 4, bounds: [{x: 300, y: 120}, {x: 330, y: 150}] }, {rate: 4, bounds: [{x: 330, y: 120}, {x: 360, y: 150}] },
          {rate: 4, bounds: [{x: 0, y: 150}, {x: 30, y: 180}] }, {rate: 4, bounds: [{x: 30, y: 150}, {x: 60, y: 180}] }, {rate: 4, bounds: [{x: 60, y: 150}, {x: 90, y: 180}] }, {rate: 4, bounds: [{x: 90, y: 150}, {x: 120, y: 180}] }, {rate: 4, bounds: [{x: 120, y: 150}, {x: 150, y: 180}] }, {rate: 3, bounds: [{x: 180, y: 150}, {x: 210, y: 180}] }, {rate: 3, bounds: [{x: 210, y: 150}, {x: 240, y: 180}] }, {rate: 3, bounds: [{x: 240, y: 150}, {x: 270, y: 180}] }, {rate: 3, bounds: [{x: 270, y: 150}, {x: 300, y: 180}] }, {rate: 3, bounds: [{x: 300, y: 150}, {x: 330, y: 180}] }, {rate: 3, bounds: [{x: 330, y: 150}, {x: 360, y: 180}] },
          {rate: 3, bounds: [{x: 0, y: 180}, {x: 30, y: 210}] }, {rate: 3, bounds: [{x: 30, y: 180}, {x: 60, y: 210}] }, {rate: 3, bounds: [{x: 60, y: 180}, {x: 90, y: 210}] }, {rate: 3, bounds: [{x: 90, y: 180}, {x: 120, y: 210}] }, {rate: 3, bounds: [{x: 120, y: 180}, {x: 150, y: 210}] }, {rate: 1, bounds: [{x: 180, y: 180}, {x: 210, y: 210}] }, {rate: 1, bounds: [{x: 210, y: 180}, {x: 240, y: 210}] }, {rate: 1, bounds: [{x: 240, y: 180}, {x: 270, y: 210}] }, {rate: 1, bounds: [{x: 270, y: 180}, {x: 300, y: 210}] }, {rate: 1, bounds: [{x: 300, y: 180}, {x: 330, y: 210}] }, {rate: 1, bounds: [{x: 330, y: 180}, {x: 360, y: 210}] },
          {rate: 2, bounds: [{x: 0, y: 210}, {x: 30, y: 240}] }, {rate: 2, bounds: [{x: 30, y: 210}, {x: 60, y: 240}] }, {rate: 2, bounds: [{x: 60, y: 210}, {x: 90, y: 240}] }, {rate: 2, bounds: [{x: 90, y: 210}, {x: 120, y: 240}] }, {rate: 2, bounds: [{x: 120, y: 210}, {x: 150, y: 240}] }, {rate: 1, bounds: [{x: 180, y: 210}, {x: 210, y: 240}] }, {rate: 1, bounds: [{x: 210, y: 210}, {x: 240, y: 240}] }, {rate: 1, bounds: [{x: 240, y: 210}, {x: 270, y: 240}] }, {rate: 1, bounds: [{x: 270, y: 210}, {x: 300, y: 240}] }, {rate: 1, bounds: [{x: 300, y: 210}, {x: 330, y: 240}] }, {rate: 1, bounds: [{x: 330, y: 210}, {x: 360, y: 240}] },
          {rate: 1, bounds: [{x: 0, y: 240}, {x: 30, y: 270}] }, {rate: 1, bounds: [{x: 30, y: 240}, {x: 60, y: 270}] }, {rate: 1, bounds: [{x: 60, y: 240}, {x: 90, y: 270}] }, {rate: 1, bounds: [{x: 90, y: 240}, {x: 120, y: 270}] }, {rate: 1, bounds: [{x: 120, y: 240}, {x: 150, y: 270}] }, {rate: 1, bounds: [{x: 180, y: 240}, {x: 210, y: 270}] }, {rate: 1, bounds: [{x: 210, y: 240}, {x: 240, y: 270}] }, {rate: 1, bounds: [{x: 240, y: 240}, {x: 270, y: 270}] }, {rate: 1, bounds: [{x: 270, y: 240}, {x: 300, y: 270}] }, {rate: 1, bounds: [{x: 300, y: 240}, {x: 330, y: 270}] }, {rate: 1, bounds: [{x: 330, y: 240}, {x: 360, y: 270}] },
          {rate: 1, bounds: [{x: 0, y: 270}, {x: 30, y: 300}] }, {rate: 1, bounds: [{x: 30, y: 270}, {x: 60, y: 300}] }, {rate: 1, bounds: [{x: 60, y: 270}, {x: 90, y: 300}] }, {rate: 1, bounds: [{x: 90, y: 270}, {x: 120, y: 300}] }, {rate: 1, bounds: [{x: 120, y: 270}, {x: 150, y: 310}] },
          {rate: 4, bounds: [{x: 180, y: 355}, {x: 210, y: 385}] }, {rate: 5, bounds: [{x: 210, y: 355}, {x: 240, y: 385}] }, {rate: 5, bounds: [{x: 240, y: 355}, {x: 270, y: 385}] }, {rate: 5, bounds: [{x: 270, y: 355}, {x: 300, y: 385}] }, {rate: 5, bounds: [{x: 300, y: 355}, {x: 330, y: 385}] }, {rate: 5, bounds: [{x: 330, y: 355}, {x: 360, y: 385}] },
          {rate: 4, bounds: [{x: 180, y: 385}, {x: 210, y: 415}] }, {rate: 5, bounds: [{x: 210, y: 385}, {x: 240, y: 415}] }, {rate: 5, bounds: [{x: 240, y: 385}, {x: 270, y: 415}] }, {rate: 5, bounds: [{x: 270, y: 385}, {x: 300, y: 415}] }, {rate: 5, bounds: [{x: 300, y: 385}, {x: 330, y: 415}] }, {rate: 5, bounds: [{x: 330, y: 385}, {x: 360, y: 415}] },
          {rate: 4, bounds: [{x: 180, y: 415}, {x: 210, y: 445}] }, {rate: 5, bounds: [{x: 210, y: 415}, {x: 240, y: 445}] }, {rate: 5, bounds: [{x: 240, y: 415}, {x: 270, y: 445}] }, {rate: 5, bounds: [{x: 270, y: 415}, {x: 300, y: 445}] }, {rate: 5, bounds: [{x: 300, y: 415}, {x: 330, y: 445}] }, {rate: 5, bounds: [{x: 330, y: 415}, {x: 360, y: 445}] },
          {rate: 4, bounds: [{x: 180, y: 445}, {x: 210, y: 475}] }, {rate: 4, bounds: [{x: 210, y: 445}, {x: 240, y: 475}] }, {rate: 4, bounds: [{x: 240, y: 445}, {x: 270, y: 475}] }, {rate: 4, bounds: [{x: 270, y: 445}, {x: 300, y: 475}] }, {rate: 4, bounds: [{x: 300, y: 445}, {x: 330, y: 475}] }, {rate: 5, bounds: [{x: 330, y: 445}, {x: 360, y: 475}] },
          {rate: 3, bounds: [{x: 180, y: 475}, {x: 210, y: 505}] }, {rate: 2.5, bounds: [{x: 210, y: 475}, {x: 240, y: 505}] }, {rate: 2.5, bounds: [{x: 240, y: 475}, {x: 270, y: 505}] },
          {rate: 1.5, bounds: [{x: 180, y: 505}, {x: 210, y: 535}] }, {rate: 1.5, bounds: [{x: 210, y: 505}, {x: 240, y: 535}] }, {rate: 1.5, bounds: [{x: 240, y: 505}, {x: 270, y: 535}] },
          {rate: 1, bounds: [{x: 180, y: 535}, {x: 210, y: 565}] }, {rate: 1, bounds: [{x: 210, y: 535}, {x: 240, y: 565}] }, {rate: 1, bounds: [{x: 240, y: 535}, {x: 270, y: 565}] },
          {rate: 1, bounds: [{x: 180, y: 565}, {x: 210, y: 595}] }, {rate: 1, bounds: [{x: 210, y: 565}, {x: 240, y: 595}] }, {rate: 1, bounds: [{x: 240, y: 565}, {x: 270, y: 595}] },
        ]
      },
    ];

    this.selectedType = this.positionSettings[0];
    this.image = this.positionSettings[0].image;
    this.model = this.positionSettings[0].model;
    this.selected = [];
    if (this.ctx) {
      this.redraw(this.model);
    }
  }

  mounted() {
    let canvas = <HTMLCanvasElement>document.getElementById("primaryPosition");
    canvas.addEventListener('click', (e) => {
      let pos = this.findPos(this);
      let x = e.pageX - pos.x;
      let y = e.pageY - pos.y;
      for (let i = 0; i < this.model.length; i++) {
        let item = this.model[i];
        if (item.bounds[0].x <= x && x <= item.bounds[1].x && item.bounds[0].y <= y && y <= item.bounds[1].y) {
          let ix = this.selected.indexOf(i);
          if (ix === -1) {
            this.selected.push(i);
            this.mark(item);
          } else {
            this.selected.splice(ix, 1);
            this.redraw(this.model);
          }
        }
      }
    });
    this.ctx = canvas.getContext('2d');
  }

  redraw(model) {
    this.ctx.clearRect(0, 0, 700, 700);
    for (let i = 0; i < this.selected.length; i++) {
      let item = model[this.selected[i]];
      this.mark(item);
    }
  }

  mark(item) {
    this.ctx.beginPath();
    let cx = item.bounds[0].x + (item.bounds[1].x - item.bounds[0].x) / 2;
    let cy = item.bounds[0].y + (item.bounds[1].y - item.bounds[0].y) / 2;
    this.ctx.arc(cx, cy, 10, 0, 2 * Math.PI);
    this.ctx.strokeStyle = 'red';
    this.ctx.lineWidth = 2;
    this.ctx.stroke();
  }

  findPos = function findPos(obj) {
    let primaryPosition = $('#primaryPosition');
    let offsetParent = primaryPosition.offsetParent();
    let offsetLeft = primaryPosition.offset().left;
    let offsetTop = primaryPosition.offset().top;
    let curleft = 0, curtop = 0;
    if (offsetParent) {
      curleft += offsetLeft;
      curtop += offsetTop;
      return {x: curleft, y: curtop};
    }
    return undefined;
  }

  @Watch('store', {deep: true}) onStoreChange(store: StoreModel) {
    if (store.positionRateSettings) {
      this.selectedType = this.positionSettings.find(item => {
        return item.id === store.positionRateSettings.storeTypeID;
      });
      let s = store.positionRateSettings.selected;
      if (typeof s === "string") {
        this.selected = JSON.parse(s || []);
      } else {
        this.selected = [];
      }
      if (this.selectedType) {
        this.image = this.selectedType.image;
        this.model = this.selectedType.model;
      }
      setTimeout(() => {
        this.redraw(this.model);
      }, 500);
    }
  }

  onSelectTypeChange(selectedType) {
    this.image = selectedType.image;
    this.model = selectedType.model;
    this.selected = [];
    this.redraw(this.model);
  }

  @Emit() saveRates() {
    return {indexes: this.selected, typeId: this.selectedType.id, model: this.model}
  }

}
